import React from 'react'
import { Link } from 'react-router-dom'

const ViewSearch = () => {
    return (
    <div className="foodGo">
        <Link to="/food" className="toggleTextNameC">美食餐廳</Link>
        </div>
    )
};

export default ViewSearch
